import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { theme } from "@xometry/xometry_loft";

export const ModalInputContainer = styled.div`
  margin-bottom: ${theme.space[4]};
  select {
    width: 100%;
    text-overflow: ellipsis;
  }
`;

export const ModalStyles = css`
  .modal-title {
    margin-bottom: ${theme.space[3]};
  }
  .modal-title legend {
    padding-bottom: ${theme.space[2]};
  }
  .modal-title__description {
    font-size: ${theme.fontSizes[0]};
    line-height: ${theme.lineHeights[2]};
    color: ${theme.colors.darkBlues[75]};
  }
  .additional-comments--label span {
    margin-left: ${theme.space[1]};
    font-style: italic;
    color: ${theme.colors.darkBlues[75]};
  }

  .proposal-comment--label span {
    margin-left: ${theme.space[1]};
    font-style: italic;
    font-weight: 400;
    color: ${theme.colors.darkBlues[75]};
  }
`;

export const FormErrorStyles = css`
  display: block;
  color: ${theme.colors.reds[100]};
  margin-top: ${theme.space[2]};
`;
